// Module
var code = "<div class=\"\" ng-controller=\"AboutCtrl\"> <p class=\"text-center kokokakakoko\"> Kitstajm FTW! </p> </div> ";
// Exports
export default code;